import React, { useEffect, useState } from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import { EcoCompareSelectorItemType } from 'eco-design/sections/eco-compare-selector/type';
import EcoSpace from 'eco-design/base/eco-space';
import EcoCompareSelector from 'eco-design/sections/eco-compare-selector';
import { GeneralKeys, GeneralKeys_US, GeneralKeys_PH } from '../../../../config/pageConfig';
import { useProductStore } from '../../../../ProductProvider';
import { useSpec } from './useSpec';
import style from './index.module.scss';
import data from './data';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import useProductInfo from '@/utils/hooks/useProductInfo';
import { IPageStatus } from '../../../../config/IPageStatus';
const JP_KEYS = [
    'Capacity',
    'rapid_outlets',
    'rapid_input',
    'spec_rapid_totaloutput',
    'specs_rapid_singleoutput',
    'specs_app',
    'specs_Screen Display',
    'rapid_dimensions',
    'rapid_weight',
    'specs_color',
];

const EU_KEYS = [
    'Capacity',
    'rapid_dimensions',
    'rapid_weight',
    'spec_rapid_totaloutput',
    'specs_rapid_singleoutput',
    'rapid_outlets',
    'rapid_input',
    'specs_app',
    'specs_digital_display',
];

const CompareSelector: React.FC = ({}) => {
    const { t } = useLang('powerBank.M');
    const { locale = 'jp' } = getLocal();
    let { productInfo, pageStatus } = useProductStore();
    const [href, pageHref] = useState('');
    const [text, pageText] = useState(t('btn1'));
    const IS_EU: boolean = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const IS_US: boolean = ['us', 'ca'].includes(locale);
    const IS_JP = locale === 'jp';
    const IS_PH = locale === 'ph';

    if (IS_JP) {
        productInfo = productInfo.slice(0, 3);
    } else if (IS_US) {
        productInfo = productInfo.slice(0, 2);
    } else if (IS_PH) {
        productInfo = productInfo.slice(0, 1);
    }

    useEffect(() => {
        if (IS_JP) {
            pageText(t('btn1'));
        } else if (IS_EU) {
            pageHref(`https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID`);
            pageText(pageStatus === IPageStatus.statusA ? t('Prepare_btn') : t('btn1'));
        } else {
            pageText(t('btn1'));
        }
    }, []);

    // 获取「比较参数」-欧洲
    let subs = useSpec(GeneralKeys, EU_KEYS);
    if (IS_JP) {
        subs = useSpec(GeneralKeys, JP_KEYS);
    } else if (IS_US) {
        subs = useSpec(GeneralKeys_US, EU_KEYS);
    } else if (IS_PH) {
        subs = useSpec(GeneralKeys_PH, EU_KEYS);
    }

    // 整合数据
    const item = productInfo.map((i, idx) => {
        const title = i.children?.find((child) => child?.title)?.title || '';
        return {
            label: t('new_text'),
            title: i.children?.find((child: any) => child?.title)?.title || '',
            // desc: 'body copy',
            items: productInfo.map((j) => ({
                label: j.children[0].title,
                value: j.children[0].title,
            })),
            colors: i.children?.map((j: any, idx2: number) => ({
                ...j,
                pc: j.variantImg,
                btns: [
                    {
                        className: `GtmModuleData-btn-href left-${idx + 1}-${idx2 + 1}`,
                        href: IS_JP || IS_US || IS_PH ? `https://${locale}.ecoflow.com/cart/${j.variantId}:1?channel=buy_button` : href,
                        text: text,
                        type: 'filled',
                        dataLayer: {
                            event: 'uaEvent',
                            event_name: 'checkout',
                            button_name: `${t('buynow')}_${title}`,
                            __btn_id1: `CompareSelector .left-${idx + 1}-${idx2 + 1}`,
                            __btn_id2: IS_JP || IS_US || IS_US ? `https://${locale}.ecoflow.com/cart/${j.variantId}:1?channel=buy_button` : href,
                            __btn_type: 'href',
                        },
                    },
                    {
                        className: `GtmModuleData-btn-href right-${idx + 1}-${idx2 + 1}`,
                        href: `https://${locale}.ecoflow.com/products/${j.handle}?variant=${j.variantId}`,
                        text: t('btn2'),
                        type: 'text',
                        icon: true,
                        dataLayer: {
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: title,
                            position: `Collections_${t('title')}`,
                            __btn_id1: `CompareSelector .right-${idx + 1}-${idx2 + 1}`,
                            __btn_id2: `https://${locale}.ecoflow.com/products/${j.handle}?variant=${j.variantId}`,
                            __btn_type: 'href',
                        },
                    },
                ],
            })),
            subs: subs[idx] ?? [],
        };
    });
    return (
        <div id="CompareSelector" className="GtmModuleData-section CompareSelector" data-section-id="Rapid-CompareSelector">
            <EcoSpace />
            <EcoCompareSelector
                className={style.comp}
                title={t('title')}
                linkProps={{
                    className: 'link-desc GtmModuleData-btn-href',
                    dataLayer: {
                        event: 'uaEvent',
                        event_name: 'buy',
                        product_name: 'EcoFlow RAPID',
                        position: `Collections_${t('btn')}`,
                        __btn_id1: `CompareSelector .link-desc`,
                        __btn_id2: `https://${locale}.ecoflow.com/collections/power-bank#rapid`,
                        __btn_type: 'href',
                    },
                    href: `https://${locale}.ecoflow.com/collections/power-bank#rapid`,
                    children: (
                        <>
                            <span className="children-link">{t('btn')}</span>
                            <EcoIconArrow />
                        </>
                    ),
                }}
                items={item as EcoCompareSelectorItemType[]}
            />
        </div>
    );
};
export default CompareSelector;
